import snapshotsSlices from './snapshots';

const growthsSlices = [snapshotsSlices];

export default growthsSlices;
